module.exports = __webpack_public_path__ + "static/img/1.6ee82a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/1.png
// module id = H3pG
// module chunks = 0